import React from "react";
import { Route, Routes } from "react-router-dom";
import FaqsPage from "../../pages/module-pages/faqs/FaqsPage";
import NewFaqPage from "../../pages/module-pages/faqs/NewFaqPage";
import UpdateFaqPage from "../../pages/module-pages/faqs/UpdateFaqPage";

export default function FaqNav() {
  return (
    <Routes>
      <Route path="/" element={<FaqsPage />} />
      <Route path="/new" element={<NewFaqPage />} />
      <Route path="/update" element={<UpdateFaqPage />} />
    </Routes>
  );
}
